import Schema, { array } from 'AppReact/schema';
import { today } from 'AppReact';
import { tableIncidentReport, property, group } from 'types';

export default {
  startDate: Schema('jsDate', 'primitive', { defaultValue: new Date('2020-06-01') }),
  endDate: Schema('jsDate', 'primitive', { defaultValue: today() }),
  incidentReports: Schema(tableIncidentReport, 'array', { defaultValue: [] }),
  fileName: Schema('string', 'primitive', { defaultValue: '' }),
  searchTerms: Schema('string', 'array', { defaultValue: [] }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  groups: Schema(group, 'array', { defaultValue: [] }),
  selectedPropertyIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedGroupIds: Schema('integer', 'array', { defaultValue: [] }),
  data: Schema(array('string'), 'array', { defaultValue: [[]] }),
}